import { TOOLTIP_ARROW_STYLE, TOOLTIP_CONTENT_STYLE } from 'conversations-visitor-message-history/shared/tooltipStyles';
import { NEUTRAL_1600, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import VizExTooltip from 'visitor-ui-component-library/tooltip/VizExTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ARROW_STYLE = Object.assign({}, TOOLTIP_ARROW_STYLE, {
  top: '-20px'
});
export function MessageEditorTooltip({
  children,
  content,
  placement
}) {
  return /*#__PURE__*/_jsx(VizExTooltip, {
    content: content,
    placement: placement,
    backgroundColor: WHITE,
    textColor: NEUTRAL_1600,
    contentStyle: TOOLTIP_CONTENT_STYLE,
    arrowStyle: ARROW_STYLE,
    children: children
  });
}
MessageEditorTooltip.displayName = 'MessageEditorTooltip';